import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { WhitelabelOrganisationInformationModel } from 'src/app/models/whitelabel-organisation-information.model';
import { WhiteLabel } from 'src/app/models/whiteLabel';
import { WhitelabelInformationModel } from 'src/app/models/whitelabel-information.model';
import { System } from 'src/app/models/system';

@Injectable({
  providedIn: 'root'
})

export class IdentitySystemApiClient {

  constructor(private http: HttpClient) { }

  getSystem(systemGuid: string) : Observable<System> {
    return this.http.get<System>(environment.identityUrl + "/api/system/" + systemGuid);
  }

  getWhitelabelproviders(systemGuid: string) {
    return this.http.get(environment.identityUrl + "/api/system/" + systemGuid + "/whitelabelproviders");
  }

  getFilteredWhiteLabel(systemGuid: string, search: string) {
    return this.http.get<WhitelabelInformationModel[]>(environment.identityUrl + "/api/system/" + systemGuid + "/filterWhitelabels/" + search);
  }

  getSigningsData(systemGuid: string): Observable<any[]> {
    return this.http.get<any[]>(environment.identityUrl + "/api/system/" + systemGuid + "/getSigningsByWeeknr");
  }

  async getAzureblobstorage(systemGuid: string) {
    return this.http.get(environment.identityUrl + "/api/system/" + systemGuid + "/azureblobstorage");
  }

  async postAzureblobstorage(systemGuid: string, body: any) {
    return this.http.post(environment.identityUrl + "/api/system/" + systemGuid + "/azureblobstorage", body);
  }
}
